export default function LeaveReportTable({ data }) {
  return (
    <div className="card shadow-sm border-0 mt-4">
      <div className="card-body p-0">
        <table className="table align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th>Invoice ID</th>
              <th>Client Name</th>
              <th>Company Name</th>
              <th>Created Date</th>
              <th>Due Date</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                <td>{item.invoice}</td>

                <td>
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={item.avatar}
                      alt=""
                      className="rounded-circle"
                      width="40"
                      height="40"
                    />
                    <div>
                      <div className="fw-semibold">{item.name}</div>
                      <small className="text-muted">{item.role}</small>
                    </div>
                  </div>
                </td>

                <td>{item.company}</td>
                <td>{item.created}</td>
                <td>{item.due}</td>
                <td>${item.amount}</td>

                <td>
                  <span
                    className={`badge ${
                      item.status === "Paid"
                        ? "bg-success-subtle text-success"
                        : item.status === "Sent"
                        ? "bg-primary-subtle text-primary"
                        : "bg-warning-subtle text-warning"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}